import Admin from '@/views/admin'
import Painel from '@/views/admin/painel'
import Relatorio from '@/views/admin/relatorio'

import { assistencia } from './admin/assistencia'
import { concursos } from './admin/concursos'
import { dados } from './admin/dados'
import { eixos } from './admin/eixos'
import { escalas } from './admin/escalas'
import { materiais } from './admin/materiais'
import { metas } from './admin/metas'
import { planoGoverno } from './admin/planoGoverno'
import { emendasParlamentares } from './admin/emendasParlamentares'
import { tags } from './admin/tags'
import { users } from './admin/user'
import { ods } from './admin/ods'

const routes = [
  {
    path: '/admin',
    component: Admin,
    children: [
      {
        path: '/',
        component: Painel,
        meta: {
          requiresAuth: true,
          adminAuth: true
        }
      },
      {
        path: 'painel',
        component: Painel,
        meta: {
          requiresAuth: true,
          adminAuth: true
        }
      },
      {
        name: 'admin_relatorio',
        path: 'relatorio',
        component: Relatorio,
        meta: {
          requiresAuth: true,
          adminAuth: true
        }
      },
      ...assistencia,
      ...concursos,
      ...dados,
      ...eixos,
      ...escalas,
      ...materiais,
      ...metas,
      ...planoGoverno,
      ...emendasParlamentares,
      ...tags,
      ...users,
      ...ods
    ]
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/admin.js